export const RESPONSE_STATUS: { [name: string]: number } = {
  OK: 200,
  RESOURCE_NEW: 201,
  RESOURCE_CONFLICT: 409,
};
